function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "leaf_svg__st0",
  d: "M106.003 348.768c12.848-115.627 86.282-211.197 185.781-257.238C268.378 53.37 236.62 22.365 199.921 0 62.447 65.536-2.416 227.413 54.819 370.914c14.055 35.265 34.373 66.122 58.994 92.125a321.83 321.83 0 01-7.81-114.271z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "leaf_svg__st0",
  d: "M439.482 93.253C287.34 86.361 153.924 198.646 136.859 352.197c-6.209 55.924 3.883 109.888 26.406 157.215 2.134.289 4.225.63 6.35.866 152.43 16.933 289.722-92.903 306.654-245.325 6.901-62.117-7.259-121.723-36.787-171.7zm-148.53 252.026c-48.56 75.218-93.716 132.454-100.854 127.853-7.119-4.609 26.484-69.305 75.078-144.515 48.577-75.218 93.734-132.455 100.862-127.854 7.139 4.61-26.482 69.306-75.086 144.516z"
});

var SvgLeaf = function SvgLeaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    width: 12,
    viewBox: "0 0 512 512",
    fill: "#27AE60"
  }, props), _ref, _ref2);
};

export default SvgLeaf;